import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3abfc63e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "population-highlight" }
const _hoisted_2 = { class: "pop-sign" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Population", -1))
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "highlight-text" }

import { HighlightItem } from './HighlightItem'


export default /*#__PURE__*/_defineComponent({
  __name: 'PopulationHighlight',
  props: {
    highlight: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(props.highlight.value), 1)
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(props.highlight.text), 1)
  ]))
}
}

})